// Utils
import getIcon from "utils/getIcon";

type ViewEditProps = {
	onClick: () => void;
};

const ViewEdit = ({ onClick }: ViewEditProps) => {
	return (
		<div className="cursor-pointer flex justify-center" onClick={onClick}>
			{getIcon({ icon: "viewEdit" })}
		</div>
	);
};

export default ViewEdit;
